import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Login from '../components/authentication/login';
import Register from '../components/authentication/register';
import ForgotPassword from '../components/authentication/forgot-password';
import ResetPassword from '../components/authentication/reset-password';
import RequireAuth from '../components/hoc/require-auth';
import TeacherRoute from '../components/private-route/teacher-route';
import AuthenticatedRoutes from './authenticated/';
import VideoReels from '../components/Videos/VideoReels';
import AboutUs from '../components/AboutUs/AboutUs';
import Landing from '../components/Landing/Landing';
import CreateClassPage from '../components/CreateClassPage/CreateClassPage';
import Copyright from '../components/Copyright/Copyright';
import Record from '../components/Record/Record';
import AlumniPage from '../components/Alumni/AlumniPage';


const TopLevelRoutes = () => (
  <div>
    <Switch>
      {/* Landing page route */}
      <Route exact path="/" component={Landing} />

      {/* Auth routes */}
      <Route exact path="/login" component={Login} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route path="/reset-password/:token" component={ResetPassword} />

      {/* Protected routes for all authenticated users */}
      <Route path="/dashboard" component={RequireAuth(AuthenticatedRoutes)} />
      <Route exact path="/videos" component={VideoReels} />
      <Route exact path="/about" component={AboutUs} />
      <Route exact path="/alumni" component={AlumniPage} />

      {/* Protected routes only for teachers */}
      <TeacherRoute exact path="/competitions" component={CreateClassPage} />
      <TeacherRoute exact path="/record" component={Record} />
    </Switch>
    <Copyright />
  </div>
);

export default TopLevelRoutes;